import script from "./ChildAreaProtection.vue?vue&type=script&setup=true&lang=js"
export * from "./ChildAreaProtection.vue?vue&type=script&setup=true&lang=js"

import "./ChildAreaProtection.vue?vue&type=style&index=0&id=535131c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535131c8"]])

export default __exports__